module.exports = __webpack_public_path__ + "img/logo.5f5c1621.svg";